import React, { useState } from 'react';
import AuthForm from '../AuthForm';
import ForgetPasswordForm from '../ForgetPasswordForm';
import RegistrationForm from '../RegistrationForm';
import  { useTranslation } from "react-i18next";
import styles from './auth.module.scss';

export default function Auth() {
  const [forgetPassword, setForgetPassword] = useState(false);
  const [showRegistration, setShowRegistration] = useState(false);
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <h1>
        {showRegistration ? 'Регистрация бизнеса' :
         forgetPassword ? t('NSAuth.resetPassword') || 'Восстановление пароля' :
         t('NSAuth.login')}
      </h1>
      {showRegistration ? (
        <RegistrationForm setShowRegistration={setShowRegistration} />
      ) : forgetPassword ? (
        <ForgetPasswordForm setForgetPassword={setForgetPassword} />
      ) : (
        <AuthForm setForgetPassword={setForgetPassword} setShowRegistration={setShowRegistration} />
      )}
    </div>
  )
}
